<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('admin.migration_skips.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        :footer="null"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <div class="form-container">
            <migration-skips-table :migration_id="migration_id" />
        </div>
    </a-modal>
</template>

<script>
import MigrationSkipsTable from '@/components/tables/MigrationSkips.vue';

export default {
    components: {
        MigrationSkipsTable,
    },
    data() {
        return {
            modal_visible: false,
        };
    },
    props: {
        migration_id: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
    },
};
</script>
